export const hasAnyProjectCapability = (capabilities, candidates) => candidates.some((capability) => capabilities.includes(capability));

export const getVisibleProjectTabs = (capabilities = []) => {
  const tabs = ['overview', 'work'];
  if (hasAnyProjectCapability(capabilities, [
    'budget.view', 'budget.manage',
    'funding.view', 'funding.manage',
    'expense.approve', 'expense.review-accounting',
    'accounting.view', 'accounting.manage',
  ])) {
    tabs.push('money');
  }
  if (hasAnyProjectCapability(capabilities, ['reporting.view', 'reporting.manage', 'accounting.view', 'accounting.manage'])) {
    tabs.push('reports');
  }
  if (hasAnyProjectCapability(capabilities, ['project.manage'])) {
    tabs.push('more');
  }
  return tabs;
};